import { gql } from '@anyx/common-graphql';

export const ACCOUNT_COUNTRIES = gql(/* GraphQL */ `
  query AccountCountries {
    MdCountriesUsedByAccounts {
      id
    }
  }
`);
